import React from "react";
import { useEffect } from "react";

import { TiTick } from "react-icons/ti";

import { PALETTE } from "../../common/ThemeConstants";
import Failed from "../../loading/pages/Failed";

export default function PurchaseSuccess() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="m-auto text-center align-self-center">
      <Failed separatorText="" mainDescription={"Pagamento completato"} />
      <TiTick size={64} color={PALETTE.GREEN} />
    </div>
  );
}
